import { Component, OnInit, ViewChild } from '@angular/core';
import { BudgetserviceService } from './_service/budgetservice.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { LovComponent } from '../lov/lov.component';
import { parse } from 'querystring';
declare var $;

@Component({
  selector: 'app-budgetentry',
  templateUrl: './budgetentry.component.html',
  styleUrls: ['./budgetentry.component.css']
})

export class BudgetentryComponent implements OnInit {
  @ViewChild('SalesBudget') Sale;
  @ViewChild('lovHike') lovHike;
  @ViewChild('lovHike1') lovHike1;
  @ViewChild('inputyear') year;
  @ViewChild('tblexp1') tblExpense1;
  @ViewChild('tblexp2') tblExpense2;
  @ViewChild('tblexp21') tblExpense21;
  @ViewChild('tblexp3') tblExpense3;
  @ViewChild('tblexp4') tblExpense4;
  @ViewChild('tblexp41') tblExpense41;
  lovPost: any[] = [];
  tblData: any[] = []; tblData1: any[] = []; tblData2: any[] = []; tblData3: any[] = []; tblData4: any[] = []; tblData1old: any[] = []; tblData21: any[] = []; tblData41: any[] = [];
  displayedColumns: string[] = ['Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
  displayedExpenseColumns: string[] = ['State/FO Office Name', 'Budget Head', 'Apr_2', 'May_2', 'June_2', 'July_2', 'Aug_2', 'Sep_2', 'Oct_2', 'Nov_2', 'Dec_2', 'Jan_2', 'Feb_2', 'Mar_2', 'Total Expenses', 'Total Sales (MT)', 'PMT'];

  id: string; qid: string; wherecols: string; lovname: string; count: number=0;
  Year: string; OfcName: string; StCd: string; CostCenterFo: string; newOfcName: string; newCostCenterFo: string;
  salesBud: any; expense1: any; expense2: any; expense3: any; expense4: any; tableData: any; expense21: any; expense41: any;
  apr2to: number; may2to: number; jun2to: number; july2to: number;  aug2to: number; sep2to: number;
  oct2to: number; nov2to: number; dec2to: number; jan2to: number; feb2to: number; mar2to: number;


  constructor(private _service: BudgetserviceService, public dialog: MatDialog) { }

  ngOnInit() {
    $(".loader-mn").hide();
  }

  //--- Open Lov on Modal ---//

  openDialog(): void {
    debugger;
    this.id = this.lovHike.nativeElement.attributes.id.value;
    this.qid = this.lovHike.nativeElement.attributes.queryid.value;
    this.wherecols = this.year.nativeElement.value + ';' + localStorage.getItem('IffcoUnitCodeS') + ';';
    this.lovname = this.lovHike.nativeElement.attributes.lovname.value;

    this.lovPost.push(this.id, this.qid, this.wherecols, this.lovname);

    const dialogRef = this.dialog.open(LovComponent, {
      width: '800px',
      data: this.lovPost,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.OfcName = result.COST_CENTER_DESC;
      this.StCd = result.STATE_CODE;
      this.CostCenterFo = result.COST_CENTER_FO;

      this.lovPost = [];

      if (this.qid == 'LovCostCenter') {
        this.OnYearChange( this.Year, this.StCd, this.CostCenterFo );

      }
     
    });
  }

  openDialog1(): void {
    debugger;
    this.id = this.lovHike1.nativeElement.attributes.id.value;
    this.qid = this.lovHike1.nativeElement.attributes.queryid.value;
    this.wherecols = this.year.nativeElement.value + ';' + localStorage.getItem('IffcoUnitCodeS') + ';';
    this.lovname = this.lovHike1.nativeElement.attributes.lovname.value;

    this.lovPost.push(this.id, this.qid, this.wherecols, this.lovname);

    const dialogRef = this.dialog.open(LovComponent, {
      width: '800px',
      data: this.lovPost,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.newOfcName = result.COST_CENTER_DESC;
     this.newCostCenterFo = result.COST_CENTER_FO;

      this.lovPost = [];

      if (this.qid == 'LovCostCenter') {
        this.OnYearChange(this.Year, this.StCd, this.CostCenterFo);

      }

    });
  }

  OnYearChange(Year: string, StCd: string, CostCenterFo: string) {
    this._service.getSaleBudget(Year, StCd, CostCenterFo).subscribe
      (res => {

        if (res) {
          this.salesBud = res;
          this.getExpense1(Year, StCd, CostCenterFo);
        }

      } );
   
  }

  getExpense1(Year: string, StCd: string, CostCenterFo: string) {
    this._service.getSaleExpense1(Year, StCd, CostCenterFo).subscribe
      (res => {
        if (res) {
          this.expense1 = res;
          this.getExpense2(Year, StCd, CostCenterFo);
        }
      });
  }

  getExpense2(Year: string, StCd: string, CostCenterFo: string) {
    this._service.getSaleExpense2(Year, StCd, CostCenterFo).subscribe
      (res => {
        if ( res )
        {
          debugger;
          this.expense2 = res;
          
          
          
         
      
          this.getExpense21(Year, StCd, CostCenterFo);
        }
      });
  }

  getExpense21( Year: string, StCd: string, CostCenterFo: string )
  {
    this._service.getSaleExpense21( Year, StCd, CostCenterFo ).subscribe
      ( res =>
      {
        if ( res )
        {
          this.expense21 = res;
          this.getExpense3( Year, StCd, CostCenterFo );
        }
      } );
  }

  getExpense3(Year: string, StCd: string, CostCenterFo: string) {
    this._service.getSaleExpense3(Year, StCd, CostCenterFo).subscribe
      (res => {
        if (res) {
          this.expense3 = res;
          this.getExpense4(Year, StCd, CostCenterFo);
        }
      });
  }
  
  getExpense4(Year: string, StCd: string, CostCenterFo: string) {
    this._service.getSaleExpense4(Year, StCd, CostCenterFo).subscribe
      ( res =>
      {
        debugger;
        this.expense4 = res; 
        this.getExpense41( Year, StCd, CostCenterFo );
      } );

    

  }

  getExpense41( Year: string, StCd: string, CostCenterFo: string )
  {
    this._service.getSaleExpense41( Year, StCd, CostCenterFo ).subscribe
      ( res =>
      {
        debugger;
        this.expense41 = res;
        this.getExpense5( Year, StCd, CostCenterFo );
       
      } );
  
  }

  getExpense5( Year: string, StCd: string, CostCenterFo: string )
  {
    this._service.getSaleExpense4( Year, StCd, CostCenterFo ).subscribe
      ( res =>
      {
        
        if ( this.CostCenterFo == "1010" )
        {
         
          this.tblData1 = this.tblExpense1._data;
          this.tblData2 = this.tblExpense2._data;
          this.tblData3 = this.tblExpense3._data;
          this.tblData4 = this.tblExpense4._data;

          this.tblData21 = this.tblExpense21._data;
          this.tblData41 = this.tblExpense41._data;


          let apr2 = 0.0; let may2 = 0.0; let jun2 = 0.0; let jul2 = 0.0; let aug2 = 0.0; let sep2 = 0.0; let oct2 = 0.0; let nov2 = 0.0; let dec2 = 0.0; let jan2 = 0.0;
          let feb2 = 0.0; let mar2 = 0.0; let totalExpense = 0.0;

          this.tblData1.forEach( function ( val )
          {

            let vau = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

            val.totalExpense = vau.toFixed( 2 );
            val.pmt = ( parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 ) ) * 100000 / val.totSale;

          } )


          this.tblData1.forEach( function ( val )
          {
            

            apr2 += parseFloat( val.apr2 );
            may2 += parseFloat( val.may2 );
            jun2 += parseFloat( val.jun2 );
            jul2 += parseFloat( val.jul2 );
            aug2 += parseFloat( val.aug2 );
            sep2 += parseFloat( val.sep2 );
            oct2 += parseFloat( val.oct2 );
            nov2 += parseFloat( val.nov2 );
            dec2 += parseFloat( val.dec2 );
            jan2 += parseFloat( val.jan2 );
            feb2 += parseFloat( val.feb2 );
            mar2 += parseFloat( val.mar2 );
            totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );

          this.tblData21.forEach( function ( val )
          {
            

            apr2 += parseFloat( val.apr2 );
            may2 += parseFloat( val.may2 );
            jun2 += parseFloat( val.jun2 );
            jul2 += parseFloat( val.jul2 );
            aug2 += parseFloat( val.aug2 );
            sep2 += parseFloat( val.sep2 );
            oct2 += parseFloat( val.oct2 );
            nov2 += parseFloat( val.nov2 );
            dec2 += parseFloat( val.dec2 );
            jan2 += parseFloat( val.jan2 );
            feb2 += parseFloat( val.feb2 );
            mar2 += parseFloat( val.mar2 );
            totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );

          this.tblData2.forEach( function ( val )
          {
          
            val.apr2 = apr2.toFixed( 2 );
            val.may2 = may2.toFixed( 2 );
            val.jun2 = jun2.toFixed( 2 );
            val.jul2 = jul2.toFixed( 2 );
            val.aug2 = aug2.toFixed( 2 );
            val.sep2 = sep2.toFixed( 2 );
            val.oct2 = oct2.toFixed( 2 );
            val.nov2 = nov2.toFixed( 2 );
            val.dec2 = dec2.toFixed( 2 );
            val.jan2 = jan2.toFixed( 2 );
            val.feb2 = feb2.toFixed( 2 );
            val.mar2 = mar2.toFixed( 2 );
            val.totalExpense = totalExpense.toFixed( 2 );
            val.pmt = ( parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 ) ) * 100000 / val.totSale;

          } )


          let apr2a = 0.0; let may2a = 0.0; let jun2a = 0.0; let jul2a = 0.0; let aug2a = 0.0; let sep2a = 0.0; let oct2a = 0.0; let nov2a = 0.0; let dec2a = 0.0; let jan2a = 0.0;
          let feb2a = 0.0; let mar2a = 0.0; let totalExpensea = 0.0;



          this.tblData3.forEach( function ( val )
          {

            val.totalExpense = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

          } )

          this.tblData1.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );
          this.tblData41.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );
          this.tblData3.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );
          
          

          this.tblData4.forEach( function ( val )
          {
            debugger;
            val.apr2 = apr2a.toFixed( 2 );
            val.may2 = may2a.toFixed( 2 );
            val.jun2 = jun2a.toFixed( 2 );
            val.jul2 = jul2a.toFixed( 2 );
            val.aug2 = aug2a.toFixed( 2 );
            val.sep2 = sep2a.toFixed( 2 );
            val.oct2 = oct2a.toFixed( 2 );
            val.nov2 = nov2a.toFixed( 2 );
            val.dec2 = dec2a.toFixed( 2 );
            val.jan2 = jan2a.toFixed( 2 );
            val.feb2 = feb2a.toFixed( 2 );
            val.mar2 = mar2a.toFixed( 2 );
            val.totalExpensea = totalExpense.toFixed( 2 );
            val.pmt = ( parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 ) ) * 100000 / val.totSale;

          } )
        }
        this.getExpense6( Year, StCd, CostCenterFo );
      } );



  }
  getExpense6( Year: string, StCd: string, CostCenterFo: string )
  {
    this._service.getSaleExpense41( Year, StCd, CostCenterFo ).subscribe
      ( res =>
      {
        debugger;
       
        if ( this.CostCenterFo == "1010" )
        {

          this.tblData1 = this.tblExpense1._data;
          this.tblData2 = this.tblExpense2._data;
          this.tblData3 = this.tblExpense3._data;
          this.tblData4 = this.tblExpense4._data;

          this.tblData21 = this.tblExpense21._data;
          this.tblData41 = this.tblExpense41._data;




          let apr2a = 0.0; let may2a = 0.0; let jun2a = 0.0; let jul2a = 0.0; let aug2a = 0.0; let sep2a = 0.0; let oct2a = 0.0; let nov2a = 0.0; let dec2a = 0.0; let jan2a = 0.0;
          let feb2a = 0.0; let mar2a = 0.0; let totalExpensea = 0.0; let pmt = 0.0;



          this.tblData3.forEach( function ( val )
          {

            val.totalExpense = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

            val.pmt = ( parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 ) ) * 100000 / val.totSale;

          } )

          this.tblData1.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 )  + parseFloat( val.jul2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

          } );
          this.tblData41.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );
          this.tblData3.forEach( function ( val )
          {
            debugger;
            apr2a += parseFloat( val.apr2 );
            may2a += parseFloat( val.may2 );
            jun2a += parseFloat( val.jun2 );
            jul2a += parseFloat( val.jul2 );
            aug2a += parseFloat( val.aug2 );
            sep2a += parseFloat( val.sep2 );
            oct2a += parseFloat( val.oct2 );
            nov2a += parseFloat( val.nov2 );
            dec2a += parseFloat( val.dec2 );
            jan2a += parseFloat( val.jan2 );
            feb2a += parseFloat( val.feb2 );
            mar2a += parseFloat( val.mar2 );
            totalExpensea += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );



          this.tblData4.forEach( function ( val )
          {
            debugger;
            val.apr2 = apr2a.toFixed( 2 );
            val.may2 = may2a.toFixed( 2 );
            val.jun2 = jun2a.toFixed( 2 );
            val.jul2 = jul2a.toFixed( 2 );
            val.aug2 = aug2a.toFixed( 2 );
            val.sep2 = sep2a.toFixed( 2 );
            val.oct2 = oct2a.toFixed( 2 );
            val.nov2 = nov2a.toFixed( 2 );
            val.dec2 = dec2a.toFixed( 2 );
            val.jan2 = jan2a.toFixed( 2 );
            val.feb2 = feb2a.toFixed( 2 );
            val.mar2 = mar2a.toFixed( 2 );
            val.totalExpense = totalExpensea.toFixed( 2 );
            val.pmt = ( parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 ) ) * 100000 / val.totSale;

          } )
        }

      } );

  }
  UploadNewData() {
    $(".loader-mn").show();
    this._service.UploadData(this.Year, this.CostCenterFo).subscribe
      (res => {
        $(".loader-mn").hide();
        this.OnYearChange(this.Year, this.StCd, this.CostCenterFo);
        console.log(res);
      });
  }
  AddCostCenter() {
    $(".loader-mn").show();
    this._service.AddCostCenter(this.Year, this.newCostCenterFo, this.newOfcName).subscribe
      (res => {
        $(".loader-mn").hide();
        alert('Cost Center Added Successfully!');
        console.log(res);
      });
  }
  reloadSales() {
    $(".loader-mn").show();
    this._service.ReloadSalesData(this.Year, this.CostCenterFo).subscribe
      (res => {

        this.OnYearChange(this.Year, this.StCd, this.CostCenterFo);
        $(".loader-mn").hide();
      });
  }

  SumTotal()
  {


    debugger;
    this.tblData1 = this.tblExpense1._data;
    this.tblData2 = this.tblExpense2._data;
    this.tblData3 = this.tblExpense3._data;
    this.tblData4 = this.tblExpense4._data;

    this.tblData21 = this.tblExpense21._data;
    this.tblData41 = this.tblExpense41._data;


    this.count = this.count + 1;

    let apr2 = 0.0; let may2 = 0.0; let jun2 = 0.0; let jul2 = 0.0; let aug2 = 0.0; let sep2 = 0.0; let oct2 = 0.0; let nov2 = 0.0; let dec2 = 0.0; let jan2 = 0.0;
    let feb2 = 0.0; let mar2 = 0.0; let totalExpense = 0.0;


    if ( this.CostCenterFo == "1010" )
    {
      this.tblData1.forEach( function ( val )
      {

        let vau = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

        val.totalExpense = vau.toFixed( 2 );

      } )

      this.tblData1.forEach( function ( val )
      {
        debugger;

        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 ) + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } );
      this.tblData21.forEach( function ( val )
      {
        debugger;

        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } );


      this.tblData2.forEach( function ( val )
      {
        debugger;
        val.apr2 = apr2.toFixed( 2 );
        val.may2 = may2.toFixed( 2 );
        val.jun2 = jun2.toFixed( 2 );
        val.jul2 = jul2.toFixed( 2 );
        val.aug2 = aug2.toFixed( 2 );
        val.sep2 = sep2.toFixed( 2 );
        val.oct2 = oct2.toFixed( 2 );
        val.nov2 = nov2.toFixed( 2 );
        val.dec2 = dec2.toFixed( 2 );
        val.jan2 = jan2.toFixed( 2 );
        val.feb2 = feb2.toFixed( 2 );
        val.mar2 = mar2.toFixed( 2 );
        val.totalExpense = totalExpense.toFixed( 2 );
      } )
      this.sumGrandTotal();
    }
    else
    {
      this.tblData1.forEach( function ( val )
      {

        let vau = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

        val.totalExpense = vau.toFixed( 2 );

      } )

      this.tblData1.forEach( function ( val )
      {
        debugger;

        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } );



      this.tblData2.forEach( function ( val )
      {
        debugger;
        val.apr2 = apr2.toFixed( 2 );
        val.may2 = may2.toFixed( 2 );
        val.jun2 = jun2.toFixed( 2 );
        val.jul2 = jul2.toFixed( 2 );
        val.aug2 = aug2.toFixed( 2 );
        val.sep2 = sep2.toFixed( 2 );
        val.oct2 = oct2.toFixed( 2 );
        val.nov2 = nov2.toFixed( 2 );
        val.dec2 = dec2.toFixed( 2 );
        val.jan2 = jan2.toFixed( 2 );
        val.feb2 = feb2.toFixed( 2 );
        val.mar2 = mar2.toFixed( 2 );
        val.totalExpense = totalExpense.toFixed( 2 );
      } )

      this.sumGrandTotal();
    }



   

  }

  sumGrandTotal()
  {
    debugger;
    this.tblData1 = this.tblExpense1._data;
    this.tblData2 = this.tblExpense2._data;
    this.tblData3 = this.tblExpense3._data;
    this.tblData4 = this.tblExpense4._data;
    this.tblData21 = this.tblExpense21._data;
    this.tblData41 = this.tblExpense41._data;

    let apr2 = 0.0; let may2 = 0.0; let jun2 = 0.0; let jul2 = 0.0; let aug2 = 0.0; let sep2 = 0.0; let oct2 = 0.0; let nov2 = 0.0; let dec2 = 0.0; let jan2 = 0.0;
    let feb2 = 0.0; let mar2 = 0.0; let totalExpense = 0.0;


    if ( this.CostCenterFo == "1010" ) 
    {
      this.tblData3.forEach( function ( val )
      {

        val.totalExpense = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

      } )
      this.tblData1.forEach( function ( val )
      {
        debugger;
        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } )
      

      this.tblData3.forEach( function ( val )
      {
        debugger;
        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } )
      this.tblData41.forEach( function ( val )
      {
        debugger;
        apr2 += parseFloat( val.apr2 );
        may2 += parseFloat( val.may2 );
        jun2 += parseFloat( val.jun2 );
        jul2 += parseFloat( val.jul2 );
        aug2 += parseFloat( val.aug2 );
        sep2 += parseFloat( val.sep2 );
        oct2 += parseFloat( val.oct2 );
        nov2 += parseFloat( val.nov2 );
        dec2 += parseFloat( val.dec2 );
        jan2 += parseFloat( val.jan2 );
        feb2 += parseFloat( val.feb2 );
        mar2 += parseFloat( val.mar2 );
        totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
      } )


      this.tblData4.forEach( function ( val )
      {
        debugger;
        val.apr2 = apr2.toFixed( 2 );
        val.may2 = may2.toFixed( 2 );
        val.jun2 = jun2.toFixed( 2 );
        val.jul2 = jul2.toFixed( 2 );
        val.aug2 = aug2.toFixed( 2 );
        val.sep2 = sep2.toFixed( 2 );
        val.oct2 = oct2.toFixed( 2 );
        val.nov2 = nov2.toFixed( 2 );
        val.dec2 = dec2.toFixed( 2 );
        val.jan2 = jan2.toFixed( 2 );
        val.feb2 = feb2.toFixed( 2 );
        val.mar2 = mar2.toFixed( 2 );
        val.totalExpense = totalExpense.toFixed( 2 );
      } )
    }
    else
    {
        this.tblData3.forEach( function ( val )
        {

          val.totalExpense = parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );

        } )

        this.tblData2.forEach( function ( val )
        {
          debugger;
          apr2 += parseFloat( val.apr2 );
          may2 += parseFloat( val.may2 );
          jun2 += parseFloat( val.jun2 );
          jul2 += parseFloat( val.jul2 );
          aug2 += parseFloat( val.aug2 );
          sep2 += parseFloat( val.sep2 );
          oct2 += parseFloat( val.oct2 );
          nov2 += parseFloat( val.nov2 );
          dec2 += parseFloat( val.dec2 );
          jan2 += parseFloat( val.jan2 );
          feb2 += parseFloat( val.feb2 );
          mar2 += parseFloat( val.mar2 );
          totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
        } )

          this.tblData3.forEach( function ( val )
          {
            debugger;
            apr2 += parseFloat( val.apr2 );
            may2 += parseFloat( val.may2 );
            jun2 += parseFloat( val.jun2 );
            jul2 += parseFloat( val.jul2 );
            aug2 += parseFloat( val.aug2 );
            sep2 += parseFloat( val.sep2 );
            oct2 += parseFloat( val.oct2 );
            nov2 += parseFloat( val.nov2 );
            dec2 += parseFloat( val.dec2 );
            jan2 += parseFloat( val.jan2 );
            feb2 += parseFloat( val.feb2 );
            mar2 += parseFloat(val.mar2);

            totalExpense += parseFloat( val.apr2 ) + parseFloat( val.may2 ) + parseFloat( val.jun2 )  + parseFloat( val.jul2 ) + parseFloat( val.aug2 ) + parseFloat( val.sep2 ) + parseFloat( val.oct2 ) + parseFloat( val.nov2 ) + parseFloat( val.dec2 ) + parseFloat( val.jan2 ) + parseFloat( val.feb2 ) + parseFloat( val.mar2 );
          } );

          this.tblData4.forEach( function ( val )
          {
            debugger;
            val.apr2 = apr2.toFixed( 2 );
            val.may2 = may2.toFixed( 2 );
            val.jun2 = jun2.toFixed( 2 );
            val.jul2 = jul2.toFixed( 2 );
            val.aug2 = aug2.toFixed( 2 );
            val.sep2 = sep2.toFixed( 2 );
            val.oct2 = oct2.toFixed( 2 );
            val.nov2 = nov2.toFixed( 2 );
            val.dec2 = dec2.toFixed( 2 );
            val.jan2 = jan2.toFixed( 2 );
            val.feb2 = feb2.toFixed( 2 );
            val.mar2 = mar2.toFixed( 2 );
            val.totalExpense = totalExpense.toFixed( 2 );
          } )
    }
    
  }




  save() {
    var obj = JSON.stringify({
      'Year': this.Year,
      'StateCode': this.StCd,
      'CostCenterFo': this.CostCenterFo,
      '_lst': this.tblExpense1._data,
      '_lst1': this.tblExpense2._data,
      '_lst2': this.tblExpense3._data,
      '_lst3': this.tblExpense4._data,
    });

    this._service.SaveData(obj).subscribe
      (res => {
        if (res.isSuccessStatusCode == true) {
          alert('Data saved Successfully!');
          this.OnYearChange(this.Year, this.StCd, this.CostCenterFo);
        }
      });

  }



  clear() {
    window.location.reload();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
